import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1500To1599Service {

  constructor() { }
}
